import React from 'react'
import { useState } from 'react'
import MyModal from '../../../../UI/modal/MyModal'
import AgreeDirectorForm from './AgreeDirectorForm'
import Person4Icon from '@mui/icons-material/Person4';
import SupplyBillAgreeIco from '../../../../supply/supplyBill/view/items/SupplyBillAgreeIco';

const AgreeDirectorButton = ({ writeOffActItem }) => {

    const [open, setOpen] = useState(false)

  return (
    <>
        <SupplyBillAgreeIco
            onClick={e => setOpen(true)}
            text={'Погодження директором'}
            ico={<Person4Icon />}
            value={writeOffActItem.isAgreeDirector}
        />

        <MyModal
            open={open}
            setOpen={setOpen}
            header={'Погодження'}
            disableClickOutside={true}
            content={
                <AgreeDirectorForm
                    // supplyOrderId={supplyOrderId}
                    writeOffActItemBd={writeOffActItem}
                    setOpen={setOpen}
                />
            }
        />
    </>
  )
}

export default AgreeDirectorButton